export var AdServer = /*#__PURE__*/ function(AdServer) {
    AdServer["freewheel"] = "freewheel";
    AdServer["adagio"] = "adagio";
    return AdServer;
}({});
/**
 * @public
 */ export var VodAdvertsAddonType = /*#__PURE__*/ function(VodAdvertsAddonType) {
    VodAdvertsAddonType["VMAP"] = "VMAP";
    return VodAdvertsAddonType;
}({});
export var AdsConfigProvider = /*#__PURE__*/ function(AdsConfigProvider) {
    AdsConfigProvider["Local"] = "Local";
    AdsConfigProvider["Vam"] = "Vam";
    return AdsConfigProvider;
}({});

//# sourceMappingURL=vod-adverts.enums.js.map